// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3ewaW","options":"AnswerScale_options__1dz88","selected":"AnswerScale_selected__35RlI"};